const messages = {
  title: "Price lists & product brochures",
  title_media: "Price lists & product brochures",
  description:
    "Download the latest brochures and flyers on our Bridgestone and Firestone tyres for passenger cars, SUVs and light commercial vehicles.",
  short_description:
    "Here you can find assets for social media, in-store TV and more.",
  mediaCategories: {
    products: "Products",
    brand_and_solutions: "Brand & solutions",
    season_and_promotions: "Season & promotions",
    format: "Format",
    cars_and_vans: "Car, SUV, light commercial",
    truck_and_buses: "Truck & bus",
    motorcycle: "Motorcycle",
    agriculture: "Agriculture",
    construction_machinery: "Construction machinery",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materials",
    brochures: "Product brochures",
    price_list: "Price lists",
    materials: "Materials",
    video_in_store: "Video with subtitles",
    video_online: "Video without subtitles",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Logos",
    summer: "Summer",
    winter: "Winter",
    all_season: "All season",
    promotions: "Promotions",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIA LIBRARY",
    description:
      "Welcome to the media section dedicated   \n" +
      "to Bridgestone and Firestone products.  \n <br> <br>" +
      "You will discover product visuals,   \n" +
      "logos, as well as a wide selection of   \n" +
      "banners, videos and digital materials   \n" +
      "to use on your website or on   \n" +
      "social media.  ",
    bDrive: {
      title: "Product photos",
      description:
        "Current images   \n" +
        "can be downloaded   \n" +
        "from our B-\n" +
        "DRIVE portal.  ",
    },
  },
  buttons: {
    media: "DISCOVER",
  },
  searchMedia: "Enter keyword",
  searchResults: "Search results",
};

export default {
  messages,
};
